import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ArrowBackIcon } from '@chakra-ui/icons'
import { Alert, AlertIcon, Box, Button, FormControl, Heading, Image, Input, Stack, Text, useMediaQuery, VStack } from '@chakra-ui/react'
import SessionStartLogo from '../../components/SessionStartLogo'
import clientAxios from '../../config/axios'
import { Toaster, toast } from 'react-hot-toast'

const quilmesImages = require.context('../../assets/images', true)

const ResendEmailPassword = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [isLargerThan1280] = useMediaQuery('(min-width: 1367px)')
  const [resend, setResend] = useState(false)
  const [email, setEmail] = useState(() => {
    const email = sessionStorage.getItem('email')

    return email
  })

  const handleResendEmail = (e) => {
    e.preventDefault()

    clientAxios.post('/auth/sendPasswordResetEmail', { email })
      .then(res => {
        console.log(res)
        if (res.status === 201) {
          setResend(true)

          setTimeout(() => {
            setResend(false)
          }, 3000)
        }
      })
  }

  return (
    <Box
      className='boxInvited'
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box bg='white' mx={'auto'}
        {...(isLargerThan768
          ? { width: '50%' }
          : null)}
      >
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          margin= {{ md: '0 auto' }}
          padding={'3rem 1rem 2rem 1rem'}
          w={{ base: '100%', md: '63%' }}
          onSubmit={handleResendEmail}
          {...(isLargerThan1280
            ? { paddingTop: '12rem' }
            : isLargerThan768
              ? { paddingTop: '3rem' }
              : {})}
        >
          <SessionStartLogo />
          <Link to={'/'}>
            <ArrowBackIcon color={'#0A0808'} h={6} marginTop={{ base: 6, md: 4 }} w={6} />
          </Link>
          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'2rem'}>
            Recuperar contraseña
          </Heading>
          <Text fontSize={'0.8rem'} fontWeight={'400'} w={{ base: '100%', md: '85%' }} >
            Se envió un correo electrónico a <b>{email}</b> con las instrucciones para recuperar tu contraseña.
            Si no lo recibiste, verificá que el correo electrónico esté bien escrito e intentalo de nuevo.
          </Text>

          <Stack paddingTop={'1rem'} w={{ base: '100%', md: 400 }}>
            <FormControl className='floating-label-group'>
              <Input
                isDisabled
                className='input'
                id='email'
                name='email'
                placeholder=' '
                type='text'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label
                className='placeholder'
                htmlFor='email'

              >
                Correo electrónico *
              </label>
            </FormControl>
          </Stack>

          <Stack
            justifyContent='center'
            paddingTop={5}
            w={{ base: '100%', md: 400 }}
          >
            {/* {resend && (
            <Alert fontSize={'14px'} status='success'>
              <AlertIcon />
              ¡Listo! Revisa tu correo electrónico.
            </Alert>
           )} */}
            <Button
              _focusVisible={{ outline: 'none' }}
              type='submit'
              variant={'btn-quilmes'}
            >
              Reenviar correo electrónico
            </Button>
          </Stack>

        </VStack>

      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default ResendEmailPassword
